  @if(isLoading){
    <afcu-loading target="appointment" class="absolute top-[30%] left-[45%]"/>
  } @else {
    <div class="flex gap-8 pt-8">
      <div class="flex flex-col gap-4 w-full">
        @if (typeof toNumber(apptID) == 'number') {
          @if(origin === 'queue'){
            <afcu-banner [content]="bannerSuccess" [state]="'success'"/>
          } @else if (origin === 'check-in'){
                @if(late === 'true'){
                  <afcu-banner [content]="bannerCheckinLate" [state]="'warning'"/>
                } @else { 
                  <afcu-banner [content]="bannerCheckinSuccess" [state]="'success'"/>
                }
          } @else {
            <afcu-banner [content]="bannerSuccess" [state]="'success'"/>
          }
        }
          <div [class]="(origin !== 'queue' && origin !== 'check-in') ? 'justify-center' : 'justify-normal'" class="sm:flex-gap-0 md:flex lg:flex">
          @if(origin !== 'queue' && origin !== 'check-in' ) {
               <div class="w-4/5 mb-6 mx-auto md:w-1/2 lg:w-1/2 flex justify-end">
              <div class="overflow-hidden rounded-[2px] h-35 w-full md:h-36 md:w-2/3 md:order-none order-1 ">
                <img [src]="schedulerService.branchSelected().imageUrl" class="h-36 w-full md:w-9/10 lg:w-9/10 object-cover">
              </div>
            </div>
          }
          
            <div [class]="(origin === 'queue' || origin === 'check-in') ? 'w-full' : 'w-full md:w-1/2 lg:w-1/2'" class="flex flex-col gap-4">
            @if(origin !== 'queue' && origin !== 'check-in') {
              <div class="flex justify-between pr-3">
                <div>
                  <div class="font-semibold">{{this.getText().yourAppointment.titles.location}}</div>
                  <div>{{schedulerService.branchSelected().locationName}}</div>
                  <div>{{address.street}}</div>
                  <div>{{address.city}}, {{address.stateZip}}</div>
                </div>
                <div class="flex gap-2 py-2 px-3">
                  <img src='/icons/map.svg' height="16" width="16">
                  <button class="font-semibold text-sm text-afcu-navy-800 cursor-pointer" (click)="openMapWithDirections(schedulerService.branchSelected().address)">Driving directions</button>
                </div>
              </div>
            }
      
            @if(origin !== 'queue' && origin !== 'check-in') {
            <div>
              <div class="font-semibold">{{this.getText().yourAppointment.titles.service}}</div>
              <div class="flex items-center gap-7 justify-between">
                <div>{{schedulerService.payload()['services']}}</div>
                <div class="flex gap-2 py-2 px-3">
                  <img src='/icons/empty-info.svg' height="16" width="16">
                  <button class="font-semibold text-sm text-afcu-navy-800 cursor-pointer" (click)="scroll()">View service details</button>
                </div>
              </div>
            </div>
          }

          @if(origin == 'queue' || origin == 'check-in') {
           <div>
              <div class="font-bold text-xl">{{this.getText().yourAppointment.titles.service}}: {{schedulerService.payload()['services']}}</div>
              <p>{{category.service.description}}</p>

              @if(calendar.date !== '')
                {
                  <div>{{calendar.date}} &#64; {{calendar.time}}</div>
                }

              <div class="flex items-center gap-7 justify-between">
                <div class="flex gap-2 py-2 px-3">
                </div>
              </div>
            </div>

          @if(category.service.serviceDetails) {
            <div>
              <div class="font-semibold text-base">{{this.getText().yourAppointment.titles.additionalDetails}}</div>
              <p class="">{{category.service.serviceDetails}}</p>
              <div class="flex items-center gap-7 justify-between">
                <div class="flex gap-2 py-2 px-3">
                </div>
              </div>
            </div>
            }
          }
            
          @if(origin != 'check-in') {
            @if(calendar.date !== ''){
              <div>
                <div class="font-semibold">{{this.getText().yourAppointment.titles.dateTime}}</div>
                <div>{{calendar.date}}</div>
                <div>{{calendar.time}}</div>
              </div>
            }
          }
            
            @if(origin !== 'queue' && origin !== 'check-in') {
            <div>
              <div class="font-semibold">{{this.getText().yourAppointment.titles.info}}</div>
              <div>{{schedulerService.payload()['contact-info'].fullName}}</div>
              <div>{{maskEmail(schedulerService.payload()['contact-info'].email)}}</div>
              <div>{{maskPhone(schedulerService.payload()['contact-info'].phone)}}</div>
              @if(schedulerService.payload()['contact-info'].membershipNumber) {
                <div>Membership: {{maskLast3(schedulerService.payload()['contact-info'].membershipNumber)}}</div>
              }
            </div>
          }
            @if(origin !== 'queue' && origin !== 'check-in') {
             <div class="font-semibold text-sm flex flex-col sm:flex-row gap-4 items-center sm:items-start justify-center sm:justify-start">
                <button class="w-full sm:w-auto py-2.5 px-5 flex justify-center gap-2 text-afcu-navy-800 border-afcu-navy-800 border cursor-pointer" (click)="createCalendar()"> <img src="/icons/empty-calendar.svg" height="20" width="20"/> {{this.getText().yourAppointment.titles.calendarAdd}}</button>
                <button class="py-2.5 px-5 flex gap-2 text-red-800 w-fit cursor-pointer" (click)="modalService.openModal('cancel/' + apptID, 'cancel')"> <img src="/icons/cancel.svg" height="20" width="20"/> {{this.getText().yourAppointment.titles.cancel}}</button>
              </div>
            }
          </div>
        </div>
        
      @if(origin !== 'queue' && origin !== 'check-in') {
        <div id="service-detail" class="border-t flex flex-col py-4 border-gray-400 text-gray-800">
          <div class="font-bold text-lg">{{this.getText().yourAppointment.titles.serviceDetails}}</div>
          <div>{{category.service.description}}</div>
        </div>
        @if(category.service.serviceDetails) {
          <div class="font-bold text-lg">{{this.getText().yourAppointment.titles.additionalDetails}}</div>
          <div> {{category.service.serviceDetails}} </div>
        }
      }

         @if(origin == 'queue' || origin == 'check-in') {
          <div class="flex items-center gap-2 mb-45">
          <button (click)="backToSplash()" class="bg-afcu-navy-800 py-4 text-white rounded-xs w-24" >{{this.getText().yourAppointment.titles.done}}</button>
          <p class="ml-0.5 text-gray-600">{{this.getText().yourAppointment.titles.closing}}{{ countdown() }} {{this.getText().yourAppointment.titles.seconds}}.</p>
          </div>
         }
      </div>
    </div>
  }

